import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CookieDisclaimer from "../components/CookieDisclaimer";
import SEO from "../components/SEO";
import "../styles.css";

export default function GTA6Challenge() {
  return (
    <>
      <SEO
        title="GTA VI Law Abiding Citizen Challenge"
        description="Can you complete GTA VI without breaking the law? Coming January 2027 - A mission-by-mission breakdown of every crime required, workarounds, and the rules for a law-abiding playthrough."
        keywords="GTA VI, GTA 6, law abiding citizen, challenge, no crime playthrough, mission analysis, rules, Vice City"
        url="https://zemaxi.com/gta6-challenge"
      />
      <Navbar />
      <CookieDisclaimer />
      <main>
        <section className="gta6-challenge-hero">
          <div className="container">
            <h1>GTA VI <span className="highlight">Law Abiding Citizen</span> Challenge</h1>
            <p>Coming January 2027</p>
          </div>
        </section>

        <section className="gta6-challenge-content">
          <div className="container">
            {/* Introduction */}
            <div className="gta6-intro">
              <h2>The <span className="highlight">Challenge</span></h2>
              <p>
                Coming January 2027 - I will examine every GTA VI story mission for required crimes. The goal: complete the game as a "law-abiding citizen" — 
                avoiding all unnecessary crime as much as possible, only acting in self-defense or when the mission script gives me absolutely no choice.
              </p>
            </div>

            {/* Coming Soon Section */}
            <div className="gta6-coming-soon">
              <h2>Coming <span className="highlight">January 2027</span></h2>
              <p>
                The GTA VI Law Abiding Citizen Challenge guide is not yet available. Once the game releases, I will meticulously analyze each mission to determine:
              </p>
              
              <div className="coming-soon-grid">
                <div className="coming-soon-item">
                  <h3><i className="fas fa-gavel"></i> Crime Analysis</h3>
                  <p>Detailed breakdown of mandatory crimes versus optional actions in each mission.</p>
                </div>
                <div className="coming-soon-item">
                  <h3><i className="fas fa-shield-alt"></i> Law-Abiding Strategies</h3>
                  <p>Optimal approaches to complete missions while minimizing criminal activity.</p>
                </div>
                <div className="coming-soon-item">
                  <h3><i className="fas fa-book"></i> Complete Rule Set</h3>
                  <p>Comprehensive rules for what constitutes a "law-abiding" playthrough in GTA VI.</p>
                </div>
                <div className="coming-soon-item">
                  <h3><i className="fas fa-map-marked-alt"></i> Mission Guide</h3>
                  <p>Step-by-step strategies for each story mission with crime-minimizing tactics.</p>
                </div>
              </div>
            </div>

            {/* Anticipated Features */}
            <div className="gta6-features">
              <h2>What to <span className="highlight">Expect</span></h2>
              
              <div className="features-grid">
                <div className="feature-item">
                  <h3><i className="fas fa-city"></i> Vice City Analysis</h3>
                  <p>Complete analysis of missions set in the reimagined Vice City and surrounding areas.</p>
                </div>
                <div className="feature-item">
                  <h3><i className="fas fa-users"></i> Dual Protagonist Coverage</h3>
                  <p>Strategies for both protagonists and how their storylines intersect with the law-abiding challenge.</p>
                </div>
                <div className="feature-item">
                  <h3><i className="fas fa-car"></i> Vehicle & Traffic Laws</h3>
                  <p>Updated traffic law analysis for GTA VI's enhanced driving mechanics and police systems.</p>
                </div>
                <div className="feature-item">
                  <h3><i className="fas fa-star"></i> Side Activities</h3>
                  <p>Guidance for side missions and activities that can be completed without breaking the law.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
